module.exports = __webpack_public_path__ + "static/media/aerologix_white_logo.142a4b27.svg";